import React, { createContext, useState, useContext, useEffect } from 'react';
import Exchange from '..'
import Actions from './Actions'
import { fetchMarkets } from 'store/actions'
import { useDispatch } from 'react-redux'

// Create the context
const SelectedMarketContext = createContext();

// Create a provider component
export const SelectedMarketProvider = ({ children }) => {
  // State for the selected market
  const [selectedMarket, setSelectedMarket] = useState('ETH-USDT');

  // Provide context value
  const contextValue = {
    selectedMarket,
    setSelectedMarket
  };

  return (
    <SelectedMarketContext.Provider value={contextValue}>
      {children}
    </SelectedMarketContext.Provider>
  );
};

export const useSelectedMarket = () => {
  const context = useContext(SelectedMarketContext);

  // Optional: Add error handling
  if (!context) {
    throw new Error('useSelectedMarket must be used within a SelectedMarketProvider');
  }

  return context;
};

const Spot = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchMarkets({
      type: 'SPOT',
    }))
  }, []);
  return (
    <SelectedMarketProvider>
      <Exchange>
        <Actions />
      </Exchange>
    </SelectedMarketProvider>
  )
}

export default Spot
